"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const DatePickerFilter_1 = __importDefault(require("./DatePickerFilter"));
const constants = __importStar(require("./constants"));
const ControlledDatePickerFilter = (props) => {
    const { value, disabled } = props;
    const fromDate = value.find(d => d.startsWith(constants.GREATER)) || '';
    const fromPickerDate = fromDate.slice(0, fromDate.indexOf('T')).replace(constants.GREATER, '');
    const toDate = value.find(d => d.startsWith(constants.LOWER)) || '';
    const toPickerDate = toDate.slice(0, toDate.indexOf('T')).replace(constants.LOWER, '');
    const handleFromChange = (0, react_1.useMemo)(() => (e) => {
        if (e.value !== '') {
            if (toPickerDate === '' || Date.parse(e.value) <= Date.parse(toPickerDate)) {
                const dates = value.filter(d => !d.startsWith(constants.GREATER));
                dates.push(constants.GREATER + e.value + constants.STARTTIME);
                props.handleDatePickerChange(dates);
            }
        }
        else {
            const dates = value.filter(d => !d.startsWith(constants.GREATER));
            if (dates.length > 0) {
                props.handleDatePickerChange(dates);
            }
            else {
                props.handleDatePickerChange([]);
            }
        }
    }, [value, toPickerDate, props]);
    const handleToChange = (0, react_1.useMemo)(() => (e) => {
        if (e.value !== '') {
            if (fromPickerDate === '' || Date.parse(e.value) >= Date.parse(fromPickerDate)) {
                const dates = value.filter(d => !d.startsWith(constants.LOWER));
                dates.push(constants.LOWER + e.value + constants.ENDTIME);
                props.handleDatePickerChange(dates);
            }
        }
        else {
            const dates = value.filter(d => !d.startsWith(constants.LOWER));
            if (dates.length > 0) {
                props.handleDatePickerChange(dates);
            }
            else {
                props.handleDatePickerChange([]);
            }
        }
    }, [fromPickerDate, value, props]);
    return (React.createElement(DatePickerFilter_1.default, { id: props.id, key: `${props.id}-date-picker`, from: fromPickerDate, to: toPickerDate, handleFromChange: handleFromChange, handleToChange: handleToChange, disabled: disabled }));
};
exports.default = ControlledDatePickerFilter;
